import { InlineText2, Reload16 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';
import { TBetPositionTheme } from '../../types';
import * as styles from './FatalError.css';

interface IFatalErrorProps {
  theme: TBetPositionTheme;
  onReloadClick(): void;
}

export const FatalError = ({ theme, onReloadClick }: IFatalErrorProps) => {
  return (
    <div className={styles['wrapper']}>
      <InlineText2 color="current_color">Позиция не найдена</InlineText2>

      <div className={classNames(styles['reload_button'], styles[theme])}>
        <Reload16 display="block" cursor="pointer" color="current_color" onClick={onReloadClick} />
      </div>
    </div>
  );
};
